export const getDetectedLanguage = (
  languageCookieValue: string | null | undefined,
  supportedLanguages: Record<string, string>
) => {
  const language = languageCookieValue || navigator.language;

  return getLanguageCode(language, supportedLanguages);
};

export function getLanguageCode(
  language: string,
  supportedLanguages: Record<string, string>
) {
  const normalized = language.toLowerCase();

  const exactLanguageMatch = Object.values(supportedLanguages).find(
    (l) => l.toLowerCase() === normalized
  );

  if (exactLanguageMatch) {
    return exactLanguageMatch;
  }

  const fallbackLanguageMatch = Object.values(supportedLanguages).find(
    (l) => l.toLowerCase() === language.slice(0, 2)
  );

  return fallbackLanguageMatch ?? navigator.language;
}
